import { Box, Button, Flex, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import privacy from "../../assets/TERMS OF USE.jpg";

const TermOfUse = () => {
  return (
    <Box w={"100%"} textAlign={"left"}>
      <Image src={privacy} w={"100%"} />
      <Box px={14} py={10}>
        <Heading color={"#3C375F"} mt={5} className="oswald-font">
          Terms of Use
        </Heading>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={4}
          className="oswald-font"
        >
          Terms and Conditions
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          Welcome to Wishfy! This document is an electronic record and is
          important for you to know. It’s published in accordance with the law
          and outlines the rules and policies that govern your use of the Wishfy
          platform (www.wishfy.io), which we’ll refer to as the “Platform.”
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Our Details:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          Wishfy is owned by Wishfy Technologies Private Limited. Our corporate
          office is located at Suite 202, H-166, Sector 63, Noida, 201301.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Your Agreement:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          When you use Wishfy and its services, you are agreeing to these Terms
          and Conditions (“Terms of Use”). These terms also include our
          policies, so please read them carefully. By using Wishfy, you are
          entering into a contract with Wishfy Technologies Private Limited, the
          owner of the Platform. These terms and policies are legally binding
          between you and Wishfy.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Who you are:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          In these Terms of Use, “You” or “User” means anyone who becomes a
          buyer on the Platform by providing their information during
          registration. “Wishfy,” “We,” “Us,” and “Our” refer to Wishfy
          Technologies Private Limited.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Additional Rules:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          When you use any of our services on the Platform (like Product Reviews
          or Seller Reviews), you must follow the rules and policies specific to
          that service. These rules become a part of these Terms of Use. We can
          change, modify, add, or remove parts of these Terms of Use at any time
          without notifying you in advance. Please check these Terms of Use
          regularly for updates or changes. If you continue to use the Platform
          after we make changes, it means you accept and agree to the updated
          terms.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Your Access:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          As long as you follow these Terms of Use, we give you permission to
          use the Platform for your personal use. This permission is personal,
          non-transferable, and limited. By using the Platform, you also agree
          to follow Wishfy’s policies, including our Privacy Policy, which may
          change over time. If you have any questions or need further
          clarification about our terms and conditions, please feel free to
          contact our support team at support@wishfy.io. Thank you for choosing
          Wishfy!
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          User Account and Security:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * When you use Wishfy, you’re responsible for keeping your username
          and password safe. If you provide false or incomplete information, we
          can suspend or terminate your account. * If you suspect any
          unauthorized use of your account, let us know right away, and make
          sure to log out after each session.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Services Offered:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Wishfy offers various services through its platform, such as buying
          home decor, furnishings, furniture, and kitchen tools from different
          brands. <br />
          * The specific terms for buying and returning products are mentioned
          in our policies, so check them out if needed. <br />
          * We expect products to be returned unused, in good condition, and
          with original tags. If not, we can’t process refunds, and you won’t be
          eligible. <br />
          * Sometimes, product descriptions may have errors, but we’re not
          responsible for that. <br />
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Platform for Transactions and Communication:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Wishfy connects buyers and sellers for transactions, but we’re not
          part of those transactions. <br />
          * We don’t guarantee product quality, pricing, or the performance of
          any transaction. <br />
          * If there’s a problem with a transaction, it’s between the buyer and
          seller. <br />
          * Wishfy is a platform for communication and doesn’t have ownership or
          liability for products or transactions. <br />
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          User Conduct and Rules:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Be responsible and follow these principles when using Wishfy: <br />
          * Don’t share someone else’s info without permission.
          <br /> * Don’t post harmful, offensive, or false content.
          <br /> * Don’t send spam or engage in illegal activities.
          <br /> * Don’t interfere with others’ use of the platform. <br />*
          Respect intellectual property rights.
          <br /> * If we suspect fraudulent activity, we can take actions like
          cancelling orders, depending on specific criteria.
          <br /> * We don’t facilitate business-to-business transactions, so
          please refrain from using the platform for that purpose.
          <br /> * Follow the law, don’t misuse the platform, and respect
          others’ rights and privacy.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Disclaimer:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Wishfy doesn’t guarantee product accuracy or quality.
          <br />
          * We’re not responsible for any content posted by users.
          <br />
          * You’re responsible for the information you provide.
          <br />
          * We’re not responsible for any loss or damage resulting from using
          the platform.
          <br />
          * We may have links to third-party websites, but we don’t control
          their content.
          <br />
        </Text>
        <Text color={"#200E32"} fontSize={"18px"} mt={5} lineHeight={1.2}>
          Please remember to follow these guidelines when using wishfy to ensure
          a positive experience for everyone.
        </Text>
        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Content on our platform:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Everything you see on Wishfy, like text, images, logos, and sounds,
          is created by our users, not us. We don’t control this content; it
          belongs to our users.
          <br />
          * However, by using our platform, you give us the right to use this
          content for various purposes, including promotions and advertising.
          This right is worldwide, perpetual, and transferable.
          <br />* You can use the information on our platform for personal,
          non-commercial purposes, but don’t remove any notices, modify the
          information, or use it for anything else.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Our responsibility and liability:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Our platform, its materials, and the services are provided as-is,
          and we can’t guarantee they’ll always be available or error-free.
          <br />
          * We don’t control the accuracy or completeness of information on our
          platform.
          <br />* If a product can’t be delivered due to state laws, the seller
          will refund you.
          <br />* By providing your phone number, you agree to receive updates
          about your orders through calls and SMS but not promotional calls or
          SMS.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Selling on our platform:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * If you’re a seller on our platform, you must follow our policies and
          ensure the items you list don’t infringe on others’ rights.
          <br />
          * You can only list items you have in stock, and your descriptions
          must be accurate.
          <br />* Don’t list the same product in multiple categories.
          <br />* We can delete multiple listings of the same product in
          different categories.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Communication on our e-platform:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Wishfy is an online platform that lets you buy products listed on
          it. We’re just the facilitator; we’re not part of the transactions.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Indemnity:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * You’ll protect and defend Wishfy, its affiliates, and their
          employees if someone claims we’ve done something wrong because of your
          actions on our platform.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Trademarks, Copyright, and Restrictions:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Materials on Wishfy are for personal, non-commercial use. Don’t
          copy, modify, or distribute them without permission.
          <br />
          * If you upload content, you grant us the right to use it for our
          business, royalty-free.
          <br />
          * Exception: Greeting cards, invitations, and memes are not covered by
          this copyright section.
          <br />
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          fontWeight={"bold"}
          lineHeight={1.2}
        >
          These terms are here to ensure a fair and safe experience for everyone
          on Wishfy.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Limitation of Liability:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          We won’t be liable for any indirect, punitive, incidental, special, or
          consequential damages resulting from:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          * Using or not being able to use our services or products.
          <br />
          * Unauthorized access to your data.
          <br />
          * Problems with products from manufacturers.
          <br />* Any other matters related to our services, including loss of
          data, profits, or use.
          <br />
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          fontWeight={"bold"}
          lineHeight={1.2}
        >
          We’re not responsible for any disruptions due to maintenance or
          unplanned outages. If you download anything from us, it’s at your own
          risk.
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={8}
          fontWeight={"bold"}
          lineHeight={1.2}
        >
          Our liability is limited to the value of the products you bought.
          We’re not responsible for disputes between users.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Termination:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          We can suspend or terminate your use of Wishfy if we think you’ve
          broken these terms or acted unethically. Even if your account is
          terminated, we may keep your transaction details for tax or regulatory
          reasons.
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          We can also terminate your account if you use a false email address,
          break our policies, or have malicious intent.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Jurisdictional Issues/sale in india only:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          Our platform is meant for sales in India. If you access it from
          another location, you’re responsible for complying with local laws.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Governing law:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          These terms are governed by Indian law, and any disputes will be
          handled in New Delhi.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Contacting the seller:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          If you need to contact us about a seller, you can click on the
          seller’s name on the product listing pages or reach out to our
          customer support.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Disclaimer:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          You use our services at your own risk. We’re not responsible for
          actions or inactions of sellers or manufacturers. We don’t guarantee
          product quality, accuracy, or legality.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Cart Notification:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          If a product in your cart is out of stock, we may offer a similar
          product from another seller at a different price.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Multiple Sellers:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          For some styles, multiple sellers may offer the same product at
          different prices. You can see all prices on the product display page.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Convenience fee:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          We may charge a convenience fee on low-value orders. The fee will be
          specified on the shopping bag page. It’s your responsibility to comply
          with payment laws.
        </Text>

        <Text
          color={"#3C375F"}
          fontWeight={"bold"}
          fontSize={20}
          mt={10}
          className={"oswald-font"}
        >
          Grievance Officer:
        </Text>
        <Text
          color={"#200E32"}
          fontSize={"14px"}
          mt={4}
          lineHeight={1.2}
          className="lato-font"
        >
          For any concerns or complaints, you can contact our Grievance Officer:
        </Text>

        <Flex alignItems={"center"} gap={1}>
          <Text color={"#3C375F"} fontWeight={"bold"} fontSize={"16px"}>
            Name:
          </Text>
          <Text color={"#200E32"} fontSize={"16px"} lineHeight={1.2}>
            Mr. Anurag Sexana
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={1}>
          <Text color={"#3C375F"} fontWeight={"bold"} fontSize={"16px"}>
            Designation:
          </Text>
          <Text color={"#200E32"} fontSize={"16px"} lineHeight={1.2}>
            Administrator
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={1}>
          <Text color={"#3C375F"} fontWeight={"bold"} fontSize={"16px"}>
            Address:
          </Text>
          <Text color={"#200E32"} fontSize={"16px"} lineHeight={1.2}>
            Suite 202, H-166, Sector 63, Noida, 201301
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={1}>
          <Text color={"#3C375F"} fontWeight={"bold"} fontSize={"16px"}>
            Email:
          </Text>
          <Text color={"#200E32"} fontSize={"16px"} lineHeight={1.2}>
            support@wishfy.io
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={1}>
          <Text color={"#3C375F"} fontWeight={"bold"} fontSize={"16px"}>
            Phone:
          </Text>
          <Text color={"#200E32"} fontSize={"16px"} lineHeight={1.2}>
            +91 99999 88453
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={1}>
          <Text color={"#3C375F"} fontWeight={"bold"} fontSize={"16px"}>
            Hours:
          </Text>
          <Text color={"#200E32"} fontSize={"16px"} lineHeight={1.2}>
            Mon-Sat (10:00 – 18:00)
          </Text>
        </Flex>

        <Text color={"#200E32"} fontSize={"14px"} mt={10} lineHeight={1.2}>
          For customer support, you can email us at support@wishfy.io or chat
          with our help desk.
        </Text>
      </Box>
    </Box>
  );
};

export default TermOfUse;
